
import Vue from "vue";

export default Vue.extend({
  name: "PortalServiciosBanner",
  props: {
    mobile: {
      type: Boolean,
      default: false
    }
  }
});
